import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$('.accordion').each(function () {

    if (inBackend) return;

    const $accordion = $(this);
    const $items = $accordion.children('.accordion-items').children('.accordion-item');


    $items.each(function () {
        const $item = $(this);
        const $header = $item.children('.accordion-header');
        const $content = $item.children('.accordion-content');

        $content.hide();
        $item.addClass('collapsed');
        $header.css('cursor', 'pointer');

        $header.on('click', function () {
            $item.toggleClass('collapsed');
            $content.slideToggle();
        });
    });


});
